import { Component, HostBinding, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { Note } from '../../../../../shared/models/note';
import { NoteService } from '../../../../../shared/services/note.service';
import { take } from 'rxjs/operators';
import { INote, IParentEntity } from 'app/shared/interfaces/entity';
import { MatDialog } from '@angular/material/dialog';
import { NoteDialogComponent } from '../../note-dialog/note-dialog.component';
import { messageService } from 'app/shared/services/messages/message.module';

@Component({
    selector: 'note-list-item',
    templateUrl: './note-list-item.component.html',
    styleUrls: ['./note-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NoteListItemComponent implements OnInit, OnDestroy {
    @HostBinding('class.selected') selected: boolean;

    _note: Note;
    _link: INote;

    onSelectedNotesChanged: Subscription;
    onItemChanged: Subscription;

    @Input() set note(val: INote) {
        this._link = val;
        if (val) {
            if (val.note) {
                this._note = val.note;
            }
            else {
                this.noteService.getById(val.noteId).pipe(take(1)).subscribe((note) => {
                    this._note = new Note(note);
                });
            }
        }
    }

    @Input() parent: IParentEntity;

    @Input() selectable = true;
    @Input() readOnly = false;

    constructor(
        public dialog: MatDialog,
        private noteService: NoteService,
    ) {
    }

    ngOnInit() {
        // Subscribe to update on selected note change
        this.onSelectedNotesChanged =
            this.noteService.onSelectedNotesChanged
                .subscribe((selectedNotes) => {
                    this.selected = false;

                    if (selectedNotes.length > 0) {
                        for (const note of selectedNotes) {
                            if (note.noteId === this._link.noteId) {
                                this.selected = true;
                                break;
                            }
                        }
                    }
                });

        this.onItemChanged = this.noteService.onItemChanged.subscribe((note) => {
            if (note.id === this._note.id) {
                this._note = note;
            }
        });
    }

    ngOnDestroy() {
      if (this.onSelectedNotesChanged) this.onSelectedNotesChanged.unsubscribe();
      if (this.onItemChanged) this.onItemChanged.unsubscribe();
    }

    onSelectedChange() {
        this.noteService.toggleSelectedNote(this._link.noteId);
    }

    readNote() {
        this.noteService.setCurrentNote(this._link.uid);
        this._link.note = new Note(this._link.note);
        this.dialog.open(NoteDialogComponent, {
            data: {
                note: this._link,
                parent: this.parent,
                readOnly: (this._link.sequenceId || this._link.readOnly || this.readOnly) ? true : false,
            },
            disableClose: true,
            autoFocus: false,
        });
    }

    toggleStar(event) {
        event.stopPropagation();
        this._note.toggleStar();
        this.saveNote();
    }

    toggleImportant(event) {
        event.stopPropagation();
        this._note.toggleImportant();
        this.saveNote();
    }

    toggleSensitive(event) {
        event.stopPropagation();
        this._note.toggleSensitive();
        this.saveNote();
    }

    notifyCopied($event) {
        messageService.success('Note copied to clipboard');
    }

    print($event) {
        this.noteService.print(this.parent, [this._link]);
    }

    saveNote() {
        this._link.note = this._note;
        const draft = (this._link && this._link.sequenceId) ? false : true;
        this.noteService.saveNote(this._link, this.parent, draft, 'Note Saved');
    }
}
